class StringService {
  static formatPhoneNumber(value) {
    if (!value) {
      return ""
    }
    return (value + "").replace(/\s/g, "").replace(/([0-9]{2})/g, "$1 ").trim()
  }

  static cleanPhoneNumber(value) {
    if (!value) {
      return null
    }
    return (value + "").replace(/\s/g, "")
  }

  static currency(value, country, displayDecimals=true) {
    const CURRENCY_MAP = {
      "FR": {
        format: "fr-FR",
        currency: "EUR"
      },
      "CH": {
        format: "de-CH",
        currency: "CHF"
      }
    }

    let country_currency = CURRENCY_MAP[country] || CURRENCY_MAP["FR"]
    const formatter = new Intl.NumberFormat(country_currency.format, {
      style: "currency",
      currency: country_currency.currency,
      maximumFractionDigits: displayDecimals ? 2 : 0
    })

    return formatter.format(value)
  }
}

export default StringService
